import { Component, OnInit, QueryList, AfterContentInit, ContentChildren, OnDestroy } from "@angular/core";
import { VNavBarService } from "@directives/_core/v-nav-bar/v-nav-bar.service.ts";
import { VNavItemComponent } from "@directives/_core/v-nav-bar/v-nav-item/v-nav-item.component";
import { Subscription } from "rxjs";
import './v-nav-bar.component.scss';

@Component({
    selector: 'v-nav-bar',
    template: require('./v-nav-bar.component.html'),
})
export class VNavBarComponent implements OnInit, OnDestroy {

    @ContentChildren(VNavItemComponent) navItems: QueryList<VNavItemComponent>;

    navItemSubscription: Subscription;

    constructor(
        private readonly navBarService: VNavBarService) { }

    ngOnInit(): void {
        this.navItemSubscription = this.navBarService.navItemChanged.subscribe(clickedItem => {
            this.navItems.forEach(item => {
                item.selected = false;
                clickedItem.selected = true;
            })
        })
    }

    ngOnDestroy(): void {
        this.navItemSubscription?.unsubscribe();
    }
}
